var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.online_fitting
      ? _c("div", { staticStyle: { "padding-top": "30px" } }, [
          _vm.$root.questions_to_include[_vm.$root.category].includes("shape")
            ? _c("img", {
                staticClass: "shape_img",
                staticStyle: { "max-width": "100px", "max-height": "100px" },
                attrs: { src: _vm.shape_img },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm.$root.questions_to_include[_vm.$root.category].includes("band")
              ? _c("span", { staticClass: "band_size" }, [
                  _vm._v("Band: "),
                  _c("b", [_vm._v(_vm._s(_vm.$root.underbust_size) + '"')]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.questions_to_include[_vm.$root.category].includes("cup")
              ? _c("span", { staticClass: "cup_size" }, [
                  _vm._v("Cup: "),
                  _c("b", [_vm._v(_vm._s(_vm.$root.cup_size) + '"')]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.questions_to_include[_vm.$root.category].includes("shape")
              ? _c("span", { staticClass: "shape" }, [
                  _vm._v("Shape: "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$root.shapeToDisplayName(_vm.$root.shape))
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.questions_to_include[_vm.$root.category].includes(
              "waist_hips"
            )
              ? _c("span", { staticClass: "shape" }, [
                  _vm._v("Waist:\n        "),
                  _c(
                    "b",
                    [
                      !_vm.$root.skipped_bottoms
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$root.waist_size) +
                                '"\n          '
                            ),
                          ]
                        : [_vm._v("\n            Skipped\n          ")],
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.questions_to_include[_vm.$root.category].includes(
              "waist_hips"
            )
              ? _c("span", { staticClass: "shape" }, [
                  _vm._v("Hip:\n        "),
                  _c(
                    "b",
                    [
                      !_vm.$root.skipped_bottoms
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$root.hip_size) +
                                '"\n          '
                            ),
                          ]
                        : [_vm._v("\n            Skipped\n          ")],
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.questions_to_include[_vm.$root.category].includes(
              "weight"
            )
              ? _c("span", { staticClass: "shape" }, [
                  _vm._v("Weight: "),
                  _c("b", [_vm._v(_vm._s(_vm.$root.weight) + '"')]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(
              "What are " +
                _vm._s(_vm.$root.is_mini_or_baby ? "they" : "you") +
                " looking for?"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container" },
            _vm._l(_vm.$root.types, function (value, key) {
              return _vm.$root.division_types[_vm.$root.category].includes(key)
                ? _c(
                    "button",
                    {
                      key: key,
                      staticClass: "btn",
                      class: { selected: _vm.$root.type === value },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.$root.type = value
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(key) + "\n      ")]
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(
              "What fit do " +
                _vm._s(_vm.$root.is_mini_or_baby ? "they" : "you") +
                " prefer?"
            ),
          ]),
          _vm._v(" "),
          _vm.online_fitting
            ? _c("div", { staticClass: "fit" }, [
                _c(
                  "div",
                  { staticClass: "range-value" },
                  [
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-wide btn-slide",
                          class: { selected: _vm.$root.fit === "loose" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$root.fit = "loose"
                            },
                          },
                        },
                        [_c("span", [_vm._v("LOOSE")])]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-wide btn-slide",
                          class: { selected: _vm.$root.fit === "normal" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$root.fit = "normal"
                            },
                          },
                        },
                        [_c("span", [_vm._v("SNUG")])]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-wide btn-slide",
                          class: { selected: _vm.$root.fit === "tight" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$root.fit = "tight"
                            },
                          },
                        },
                        [_c("span", [_vm._v("TIGHT")])]
                      ),
                    ]),
                    _vm._v(" "),
                    [
                      _vm.usePercentage
                        ? _c("div", {
                            staticClass: "left-indicator",
                            style: _vm.leftComputedStyle,
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "indicator",
                        style: _vm.computedStyle,
                      }),
                      _vm._v(" "),
                      _vm.usePercentage
                        ? _c("div", {
                            staticClass: "right-indicator",
                            style: _vm.rightComputedStyle,
                          })
                        : _vm._e(),
                    ],
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ])
      : _c("div", [_vm._v("\n    Loading...\n  ")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }